// import Button from "../Shared/Button"
import About1 from "../../assets/1.jpg"
import About2 from "../../assets/2.jpg"
import About3 from "../../assets/3.jpg"
import About4 from "../../assets/4.jpg"
import About5 from "../../assets/5.jpg"
import { CircleCheckBig } from "lucide-react"
const About = () => {
    return (
        <div className="container sm:py-20 py-12">
            <div className="flex lg:gap-10 md:gap-5 gap-10 justify-center items-center lg:flex-row flex-col">
                <div className="flex sm:gap-2 gap-1 items-center lg:min-w-[532px] sm:min-w-[380px]">
                    <div>
                        <img className="object-cover rounded-2xl sm:h-[300px] h-[250px] w-[172px]" src={About1} alt="" />
                    </div>
                    <div className="flex flex-col sm:gap-2 gap-1">
                        <img className="object-cover rounded-2xl h-[270px] sm:h-[313.5px] w-[172px]" src={About2} alt="" />
                        <img className="object-cover rounded-2xl h-[270px] sm:h-[313.5px] w-[172px]" src={About3} alt="" />
                    </div>
                    <div className="flex flex-col sm:gap-2 gap-1">
                        <img className="object-cover rounded-2xl w-[172px] sm:h-[270px] h-[230px]" src={About4} alt="" />
                        <img className="object-cover rounded-2xl w-[172px] sm:h-[230px] h-[190px]" src={About5} alt="" />
                    </div>
                </div>
                <div className="md:space-y-6 space-y-3">
                    <h1 className="text-secondary sm:text-base text-sm font-semibold">About Nile Wise</h1>
                    <h2 className="lg:text-4xl sm:text-3xl text-2xl font-semibold text-textPrimary">Welcome to Nile Wise' Training & Consulting.</h2>
                    <p className="sm:text-base text-sm">where we specialize in empowering professionals and organizations through customized training and consulting solutions. Based in Egypt, we combine local insights with global expertise to help you grow and succeed. Let us guide you in enhancing your skills and achieving your goals.
                    </p>
                    <div className="space-y-3">
                        <div className="flex gap-2 items-center">
                            <CircleCheckBig size={24} className="text-secondary sm:w-6 w-4"/>
                            <h1 className="sm:text-lg lg:text-xl text-textPrimary font-medium">Live Virtual Training</h1>
                        </div>
                        <div className="flex gap-2 items-center">
                            <CircleCheckBig size={24} className="text-secondary sm:w-6 w-4"/>
                            <h1 className="sm:text-lg lg:text-xl text-textPrimary font-medium">Face 2 Face On Site Training</h1>
                        </div>
                        <div className="flex gap-2 items-center">
                            <CircleCheckBig size={24} className="text-secondary sm:w-6 w-4"/>
                            <h1 className="sm:text-lg lg:text-xl text-textPrimary font-medium">Coaching & Mentoring</h1>
                        </div>
                        <div className="flex gap-2 items-center">
                            <CircleCheckBig size={24} className="text-secondary sm:w-6 w-4"/>
                            <h1 className="sm:text-lg lg:text-xl text-textPrimary font-medium">Self-Paced Training</h1>
                        </div>
                        <div className="flex gap-2 items-center">
                            <CircleCheckBig size={24} className="text-secondary sm:w-6 w-4"/>
                            <h1 className="sm:text-lg lg:text-xl text-textPrimary font-medium">Consultation</h1>
                        </div>

                    </div>
                    {/* <Button variant="primary" size="lg" className="w-[177px]">Our Brochure</Button> */}
                </div>
            </div>
        </div>
    )
}

export default About